// ActivityOneStatements.jsx — Mirror activity (Phase 3: real logic).
// Matches room.php's #myModal / .statement-button behavior exactly: select
// exactly 3 (brown), block a 4th until one is deselected, Submit enabled
// only at exactly 3, green/red feedback, 1 point per correct selection.
import React, { useState } from 'react';
import ActivityPopup from '../overlays/ActivityPopup';
import { MIRROR_PROMPT, MIRROR_STATEMENTS } from '../../../games/escape-to-inner-peace/data/gameText';
import '../../../games/escape-to-inner-peace/styles/theme.css';
import './ActivityOneStatements.css';

const REQUIRED_SELECTIONS = 3;
const FEEDBACK_DELAY_MS = 1500;

function ActivityOneStatements({ open, onComplete }) {
  const [selected, setSelected] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [feedback, setFeedback] = useState({});

  const toggleStatement = (id) => {
    if (submitted) return;
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      if (prev.length >= REQUIRED_SELECTIONS) {
        return prev;
      }
      return [...prev, id];
    });
  };

  const handleSubmit = () => {
    if (submitted || selected.length !== REQUIRED_SELECTIONS) return;
    setSubmitted(true);

    let correctCount = 0;
    const nextFeedback = {};
    selected.forEach((id) => {
      const statement = MIRROR_STATEMENTS.find((s) => s.id === id);
      if (statement?.correct) {
        correctCount += 1;
        nextFeedback[id] = 'correct';
      } else {
        nextFeedback[id] = 'incorrect';
      }
    });
    setFeedback(nextFeedback);

    setTimeout(() => {
      onComplete(correctCount);
    }, FEEDBACK_DELAY_MS);
  };

  const statementClass = (id) => {
    if (feedback[id]) return `escape-statement-button escape-statement-button--${feedback[id]}`;
    if (selected.includes(id)) return 'escape-statement-button escape-statement-button--selected';
    return 'escape-statement-button';
  };

  return (
    <ActivityPopup
      open={open}
      title={MIRROR_PROMPT}
      testId="escape-activity-mirror"
      footer={
        <button
          type="button"
          className="escape-submit-btn"
          disabled={selected.length !== REQUIRED_SELECTIONS || submitted}
          aria-label="Submit"
          data-testid="escape-mirror-submit"
          onClick={handleSubmit}
        />
      }
    >
      <div className="escape-statements-container">
        {MIRROR_STATEMENTS.map((statement) => (
          <button
            key={statement.id}
            type="button"
            className={statementClass(statement.id)}
            aria-pressed={selected.includes(statement.id)}
            data-testid={`escape-mirror-statement-${statement.id}`}
            onClick={() => toggleStatement(statement.id)}
            disabled={submitted}
          >
            {statement.text}
          </button>
        ))}
      </div>
    </ActivityPopup>
  );
}

export default ActivityOneStatements;
